// Central Spanish -> English catalogue. Keep UI copy here so it is shared by
// every screen, including legacy class components and third-party modals.
const translations = {
  "español": "Spanish",
  "inglés": "English",
  "idioma": "Language",
  "seleccionar idioma": "Select language",
  "cambiar idioma": "Change language",
  "desconectar": "Sign out",
  "subir al inicio": "Back to top",
  "inicio": "Home",
  "ingresar": "Sign in",
  "iniciar sesión": "Sign in",
  "usuario": "Username",
  "contraseña": "Password",
  "confirmar contraseña": "Confirm password",
  "recordar contraseña": "Remember password",
  "olvidé mi contraseña": "I forgot my password",
  "crear usuario": "Create account",
  "registrarse": "Register",
  "bienvenido": "Welcome",
  "ingreso exitoso": "Successful sign-in",
  "ahora puedes consultar y gestionar tu(s) poliza(s)": "You can now view and manage your policy or policies",
  "espera un momento, se esta cerrando tu sesión, esperamos que vuelvas pronto": "Please wait while we sign you out. We hope to see you again soon",
  "estas utilizando internet explorer, por favor intentar con otro navegador": "You are using Internet Explorer. Please try another browser",
  "error": "Error",
  "aceptar": "Accept",
  "cerrar": "Close",
  "cancelar": "Cancel",
  "continuar": "Continue",
  "regresar": "Back",
  "siguiente": "Next",
  "anterior": "Previous",
  "guardar": "Save",
  "editar": "Edit",
  "eliminar": "Delete",
  "descargar": "Download",
  "imprimir": "Print",
  "enviar": "Send",
  "buscar": "Search",
  "consultar": "View",
  "ver detalle": "View details",
  "detalle": "Details",
  "seleccione": "Select",
  "seleccionar": "Select",
  "todos": "All",
  "todas": "All",
  "sí": "Yes",
  "si": "Yes",
  "no": "No",
  "cargando": "Loading",
  "procesando": "Processing",
  "sin resultados": "No results",
  "no hay información disponible": "No information available",
  "información": "Information",
  "información general": "General information",
  "datos personales": "Personal information",
  "datos generales": "General information",
  "datos principales": "Key policy information",
  "consulta aquí los datos principales de tu seguro.": "View your policy's key information here.",
  "consulta aqui los datos principales de tu seguro.": "View your policy's key information here.",
  "nombre": "Name",
  "nombres": "First names",
  "apellido": "Last name",
  "apellidos": "Last names",
  "correo": "Email",
  "correo electrónico": "Email",
  "teléfono": "Phone",
  "celular": "Mobile phone",
  "dirección": "Address",
  "país": "Country",
  "departamento": "State / department",
  "municipio": "Municipality",
  "zona": "Zone",
  "fecha": "Date",
  "fecha de nacimiento": "Date of birth",
  "estado": "Status",
  "activo": "Active",
  "inactivo": "Inactive",
  "tipo": "Type",
  "descripción": "Description",
  "observaciones": "Notes",
  "comentarios": "Comments",
  "documento": "Document",
  "documentos": "Documents",
  "archivo": "File",
  "archivos": "Files",
  "adjuntar archivo": "Attach file",
  "número": "Number",
  "número de póliza": "Policy number",
  "no. de póliza": "Policy number",
  "no. de carné": "ID card number",
  "póliza": "Policy",
  "pólizas": "Policies",
  "mis pólizas": "My policies",
  "tipo de póliza": "Policy type",
  "póliza contratada": "Policy purchased",
  "nombre póliza": "Policy name",
  "información de póliza": "Policy information",
  "información póliza": "Policy information",
  "vigencia de poliza": "Policy term",
  "vigencia póliza": "Policy term",
  "vigencia": "Term",
  "inicio de vigencia": "Effective date",
  "fin de vigencia": "Expiration date",
  "aseguradora": "Insurance company",
  "asegurado": "Insured",
  "asegurado titular": "Primary insured",
  "titular": "Primary insured",
  "contratante": "Policyholder",
  "beneficiario": "Beneficiary",
  "beneficiarios": "Beneficiaries",
  "cobertura": "Coverage",
  "coberturas": "Coverage",
  "suma asegurada": "Sum insured",
  "prima": "Premium",
  "prima neta": "Net premium",
  "plan contratado": "Plan purchased",
  "tipo de seguro": "Insurance type",
  "fecha de emisión": "Issue date",
  "fecha de emision": "Issue date",
  "emisión poliza": "Policy issue date",
  "certificado": "Certificate",
  "ramo": "Line of business",
  "deducible": "Deductible",
  "cuota": "Installment",
  "cuotas": "Installments",
  "pago": "Payment",
  "pagos": "Payments",
  "forma de pago": "Payment method",
  "pendiente": "Pending",
  "pagado": "Paid",
  "vencido": "Past due",
  "reclamo": "Claim",
  "reclamos": "Claims",
  "nuevo reclamo": "New claim",
  "gestionar reclamo": "Manage claim",
  "gestiones": "Requests",
  "bitácora": "Activity log",
  "vehículo": "Vehicle",
  "vehículos": "Vehicles",
  "placa": "License plate",
  "marca": "Make",
  "modelo": "Model",
  "año": "Year",
  "motor": "Engine",
  "chasis": "VIN / chassis",
  "asesor": "Advisor",
  "asesor de seguros": "Insurance advisor",
  "red de proveedores": "Provider network",
  "encuentre su proveedor de salud": "Find a healthcare provider",
  "detalles del proveedor": "Provider details",
  "¿no encuentras a tu proveedor?": "Can't find your provider?",
  "proveedores": "Providers",
  "hospitales": "Hospitals",
  "procedimientos ambulatorios": "Outpatient procedures",
  "centros de imagenes": "Imaging centers",
  "centros de imágenes": "Imaging centers",
  "redes medicas": "Medical networks",
  "redes médicas": "Medical networks",
  "dentistas": "Dentists",
  "odontologos": "Dentists",
  "odontólogos": "Dentists",
  "hospitales de ciudad": "City hospitals",
  "hospitales regionales": "Regional hospitals",
  "centros de atencion integral": "Comprehensive care centers",
  "centros de atención integral": "Comprehensive care centers",
  "laboratorios": "Laboratories",
  "médicos": "Doctors",
  "medicos": "Doctors",
  "centros de diagnóstico": "Diagnostic centers",
  "centros de diagnostico": "Diagnostic centers",
  "hospitales ciudad de guatemala": "Hospitals in Guatemala City",
  "hospitales departamentales": "Regional hospitals",
  "centros integrales cdad. guatemala": "Comprehensive care centers in Guatemala City",
  "farmacias": "Pharmacies",
  "ubicación": "Location",
  "horario": "Hours",
  "contacto": "Contact",
  "contáctenos": "Contact us",
  "asistencia": "Assistance",
  "asistencias": "Assistance",
  "emergencias": "Emergencies",
  "carnet digital": "Digital ID card",
  "su carnet no se encuentra disponible en este momento.": "Your digital ID card is currently unavailable.",
  "calificación": "Rating",
  "calificar": "Rate",
  "gracias": "Thank you",
  "requerido": "Required",
  "campo requerido": "Required field",
  "debes llenar todos los campos para que puedas crear tu usuario con exito": "You must complete all fields to create your account",
  "la confirmación de la contraseña no coincide": "The password confirmation does not match",
  "creación exitosa": "Account created successfully",
  "tu usuario ha sido creado con exito, ahora puedes ingresar con tu usuario y contraseña": "Your account was created successfully. You can now sign in with your username and password",
  "validando informacion general": "Validating general information"
  ,"formulario de ingreso": "Sign-in form"
  ,"bienvenido a somit": "Welcome to Somit"
  ,"portal digital de seguros": "Digital insurance portal"
  ,"tu seguro, más claro y más cerca.": "Your insurance, clearer and closer."
  ,"consulta pólizas, asesores, pagos y gestiones desde un acceso seguro y diseñado para cualquier dispositivo.": "View policies, advisors, payments, and requests securely from any device."
  ,"gestiona tu información": "Manage your information"
  ,"mis polizas": "My policies"
  ,"datos de fianza": "Bond information"
  ,"detalle liquidacion": "Settlement details"
  ,"detalle reclamo": "Claim details"
  ,"detalle vehiculos": "Vehicle details"
  ,"documentos recientes": "Recent documents"
  ,"lista de archivos": "File list"
  ,"cargando documentos...": "Loading documents..."
  ,"cargando información": "Loading information"
  ,"cargando información, espere un momento": "Loading information, please wait"
  ,"procesando solicitud...": "Processing request..."
  ,"sin resultados encontrados": "No results found"
  ,"limpiar": "Clear"
  ,"quitar": "Remove"
  ,"generar": "Generate"
  ,"cotizar": "Get a quote"
  ,"actualización de datos cliente": "Update customer information"
  ,"cambio de contraseña": "Change password"
  ,"nueva contraseña": "New password"
  ,"confirma tu contraseña": "Confirm your password"
  ,"recuperación de usuario y contraseña": "Username and password recovery"
  ,"creación de usuario": "Create account"
  ,"campo vacio": "Empty field"
  ,"fecha de ingreso": "Entry date"
  ,"fecha de ocurrencia": "Date of occurrence"
  ,"fecha liquidación": "Settlement date"
  ,"pasos del proceso": "Process steps"
  ,"dependientes de gastos médicos": "Medical expense dependents"
  ,"beneficiarios de vida": "Life insurance beneficiaries"
  ,"gastos medicos": "Medical expenses"
  ,"tipo de reclamo": "Claim type"
  ,"reclamo de": "Claim for"
  ,"consulta de reclamos y autorizaciones gm": "Medical claims and authorizations"
  ,"creación de autorizaciones": "Create authorizations"
  ,"creación de reclamos": "Create claims"
  ,"documentos pendientes": "Pending documents"
  ,"agregar documentos pendientes": "Add pending documents"
  ,"el limite de tamaño de archivos no puede exceder los 5 mb.": "Files cannot exceed 5 MB."
  ,"puedes colocar aquí tus archivos o puedes buscarlos en tu computadora": "Drop your files here or select them from your computer"
  ,"dirección de riesgo": "Risk address"
  ,"interes o bienes": "Property or interests"
  ,"intereses o bienes": "Property or interests"
  ,"documento fianza": "Bond document"
  ,"descripción fianza": "Bond description"
  ,"garantia": "Guarantee"
  ,"información de tu asesor": "Your advisor's information"
  ,"asesor de póliza": "Policy advisor"
  ,"asesor de reclamos": "Claims advisor"
  ,"asistente de cobro": "Collections assistant"
  ,"jefe de cobros": "Collections manager"
  ,"información cobrador": "Collections representative information"
  ,"información gerente": "Manager information"
  ,"califica mi servicio": "Rate my service"
  ,"servicio al cliente": "Customer service"
  ,"detalles de contacto": "Contact details"
  ,"nuestra comunidad": "Our community"
  ,"suscríbete": "Subscribe"
  ,"primer nombre": "First name"
  ,"segundo nombre": "Middle name"
  ,"primer apellido": "Last name"
  ,"segundo apellido": "Second last name"
  ,"nombre completo": "Full name"
  ,"fecha nacimiento": "Date of birth"
  ,"nacimiento": "Date of birth"
  ,"telefono": "Phone"
  ,"telefono celular": "Mobile phone"
  ,"telefono residencial": "Home phone"
  ,"ciudad": "City"
  ,"cédula": "ID number"
  ,"dpi": "ID number"
  ,"pasaporte": "Passport"
  ,"parentesco": "Relationship"
  ,"afiliado": "Member"
  ,"dependiente": "Dependent"
  ,"enfermedad": "Medical condition"
  ,"otra enfermedad": "Other medical condition"
  ,"especialidad": "Specialty"
  ,"nombre del médico": "Doctor's name"
  ,"fecha deseada": "Preferred date"
  ,"hora preferida": "Preferred time"
  ,"teléfono de contacto": "Contact phone"
  ,"agendar cita": "Schedule appointment"
  ,"completa este formulario con los detalles de tu cita ideal y nos pondremos en contacto contigo para asistirte.": "Complete this form with your preferred appointment details and we will contact you to assist you."
  ,"¿presenta reclamo de este diagnóstico por primera vez?": "Is this your first claim for this diagnosis?"
  ,"numero de cheque / transferencia": "Check / transfer number"
  ,"observaciones liquidacion": "Settlement notes"
  ,"debes de seleccionar un pagador para ver sus requerimientos de pago": "Select a payer to view their payment requirements"
  ,"si deseas ver tus deducibles puedes verlos dando clic en cada uno de los vehiculos del listado.": "To view deductibles, select each vehicle in the list."
  ,"solo debes de dar click en el boton siguiente que se encuentra en la parte inferior izquierda de la pantalla.": "Select NEXT at the bottom-left of the screen to continue."
  ,"aviso": "Notice"
  ,"importante": "Important"
  ,"categoría": "Category"
  ,"puesto": "Position"
  ,"dirigido a": "Addressed to"
  ,"recuperar contraseña": "Recover password"
  ,"recuperar": "Recover"
  ,"en este apartado podras recuperar tu usuario y contraseña": "Here you can recover your username and password"
  ,"en este apartado podrás recuperar tu usuario y contraseña": "Here you can recover your username and password"
  ,"el cual sera enviado a tu correo registrado": "which will be sent to your registered email address"
  ,"el cual será enviado a tu correo registrado": "which will be sent to your registered email address"
  ,"dependientes": "Dependents"
  ,"biblioteca de documentos": "Document library"
  ,"administra tus documentos de póliza de forma sencilla. todos tus archivos, organizados y seguros.": "Manage your policy documents easily. All your files, organized and secure."
  ,"selecciona un tipo de documento para ver sus archivos.": "Select a document type to view its files."
  ,"no hay archivos disponibles.": "No files available."
  ,"tipo de documento": "Document type"
  ,"información estado de cuenta": "Account statement information"
  ,"estado de cuenta": "Account statement"
  ,"estado de requerimiento": "Request status"
  ,"no. requerimiento": "Request number"
  ,"prima total": "Total premium"
  ,"vencimiento": "Due date"
  ,"requerimiento": "Request"
  ,"requerimientos": "Requests"
  ,"afiliada": "Affiliate"
  ,"valor pagado": "Amount paid"
  ,"fecha de pago": "Payment date"
  ,"monto": "Amount"
  ,"acción": "Action"
  ,"actividad": "Activity"
  ,"fecha cierre": "Closing date"
  ,"fecha siniestro": "Loss date"
  ,"no. reclamo": "Claim number"
  ,"nombre reclamo": "Claim name"
  ,"tipo reclamo": "Claim type"
  ,"nombres y apellidos": "Full name"
  ,"tipo / parentesco": "Type / relationship"
  ,"direcciones": "Addresses"
  ,"intereses": "Interests"
  ,"carné": "ID card"
  ,"código": "Code"
  ,"codigo": "Code"
  ,"colonia": "Neighborhood"
  ,"inciso": "Item"
  ,"ingreso": "Entry"
  ,"uso": "Use"
  ,"tipo vehiculo": "Vehicle type"
  ,"tipo vehículo": "Vehicle type"
  ,"monto deducible": "Deductible amount"
  ,"deducible minimo": "Minimum deductible"
  ,"deducible mínimo": "Minimum deductible"
  ,"porcentaje": "Percentage"
  ,"exitoso": "Successful"
  ,"la información consultada es la gestionada por somit, correspondiente a la vigencia": "The information shown is managed by SOMIT and corresponds to the policy term"
  ,"no fue posible digitalizar, su sesión ha finalizado, vuelva a ingresar por favor.": "The document could not be digitized because your session ended. Please sign in again."
  ,"mostrando": "Showing"
  ,"documento disponible": "document available"
  ,"documentos disponibles": "documents available"
  ,"tipos de documento disponibles": "Available document types"
  ,"buscar en documentos...": "Search documents..."
  ,"resultados encontrados": "results found"
  ,"ver asesor de cobro": "View collections advisor"
  ,"ver información de tu asesor de cobro/a": "View your collections advisor's information"
  ,"asesor de cobro": "Collections advisor"
  ,"información de asesores de cobro": "Collections advisors information"
  ,"la póliza no tiene beneficiarios registrados.": "The policy has no registered beneficiaries."
  ,"no se encontro información de dependiente": "No dependent information was found"
  ,"no se encontró información de dependiente": "No dependent information was found"
  ,"la póliza no cuenta con facturas registradas.": "The policy has no registered invoices."
  ,"la póliza no cuenta con facturas pendientes ni tampoco pagadas": "The policy has no pending or paid invoices."
  ,"la póliza no cuenta con facturas pendientes ni tampoco pagadas nuevo": "The policy has no pending or paid invoices."
  ,"la póliza no cuenta con pagadores": "The policy has no payers."
  ,"la póliza no cuenta con reclamos pendientes": "The policy has no pending claims."
  ,"esta póliza no poseé reclamos ingresados": "This policy has no submitted claims."
  ,"esta póliza no posee reclamos ingresados": "This policy has no submitted claims."
  ,"no se encontro información de poliza": "No policy information was found"
  ,"no se encontró información de póliza": "No policy information was found"
  ,"no se encontro información de aseguradora": "No insurance company information was found"
  ,"no se encontró información de aseguradora": "No insurance company information was found"
  ,"no se encontro información de asesor": "No advisor information was found"
  ,"no se encontró información de asesor": "No advisor information was found"
  ,"error: no se encontro información de asesor": "Error: No advisor information was found"
  ,"no se encontro información de pagadores": "No payer information was found"
  ,"no se encontró información": "No information was found"
  ,"no se encontraron datos": "No data was found"
  ,"no se encontró bitacora para el reclamo seleccionado": "No activity log was found for the selected claim"
  ,"no se encontró bitácora para el reclamo seleccionado": "No activity log was found for the selected claim"
  ,"no se encontro información, comunicate con tu asesor !": "No information was found. Please contact your advisor."
  ,"no se encontró información, comunícate con tu asesor !": "No information was found. Please contact your advisor."
  ,"no se pudo guardar": "The information could not be saved"
  ,"no ha ingresado": "You have not signed in"
  ,"se ha almacenado correctamente tu correo": "Your email address was saved successfully"
  ,"no se pudo descargar el documento.": "The document could not be downloaded."
  ,"este documento no tiene identificador válido para descargar.": "This document does not have a valid download identifier."
  ,"aún no se ha cargado la póliza. intenta nuevamente.": "The policy has not loaded yet. Please try again."
  ,"ocurrió un error al consultar los documentos de la póliza.": "An error occurred while retrieving the policy documents."
  ,"no se pudieron cargar los datos personales": "Personal information could not be loaded"
  ,"datos personales actualizados correctamente": "Personal information updated successfully"
  ,"no se pudieron guardar los datos personales": "Personal information could not be saved"
  ,"su sesión ha expirado!!": "Your session has expired!"
  ,"ha ocurrido un error por favor intente de nuevo!!": "An error occurred. Please try again!"
  ,"no se pudo completar la acción. es necesario volver a iniciar sesión.": "The action could not be completed. Please sign in again."
  ,"actualizacion exitosa": "Update successful"
  ,"actualización exitosa": "Update successful"
  ,"tu información ha sido actualizado correctamente.": "Your information was updated successfully."
  ,"no se pudo procesar correctamente los datos": "The information could not be processed"
  ,"debes validar tu usuario y contraseña, si no cuentas con usuario puedes crearlo en la opción crear usuario": "Validate your username and password. If you do not have an account, select Create account."
  ,"su contraseña fue actualizada": "Your password was updated"
  ,"para dar tramite a tu reclamo es necesario que adjuntes la documentación del reclamo": "To process your claim, attach the required claim documents."
  ,"no puedes exceder del limite de carga de 5 mb en tus archivos": "Your files cannot exceed the 5 MB upload limit."
  ,"tu solicitud ha sido creada existosamente.": "Your request was created successfully."
  ,"debes completar los datos para que se genere el reclamo": "Complete the required information to create the claim."
  ,"se ha cargado tu información correctamente y notificado al asesor de tu reclamo": "Your information was uploaded successfully and your claims advisor was notified."
  ,"no puedes continuar con el proceso, el reclamo no existe.": "You cannot continue because the claim does not exist."
  ,"tu información ha sido confirmada, puedes proceder con tu gestión.": "Your information was confirmed. You may continue with your request."
  ,"debes validar que no eres un robot, en el cuadro de recaptcha": "Confirm that you are not a robot using the reCAPTCHA box."
  ,"debes completar los datos para continuar!": "Complete the required information to continue!"
  ,"atención": "Attention"
  ,"atencion": "Attention"
  ,"no se encontro información de gerente": "No manager information was found"
  ,"no se encontró información de tu gerente": "No information was found for your manager"
  ,"no se encontro información de asesor reclamo": "No claims advisor information was found"
  ,"ha ocurrido un error en el envio, debes comunicarte con tu asesor de póliza": "An error occurred while sending the information. Please contact your policy advisor."
  ,"ha ocurrido un error en la creación, debes comunicarte con tu asesor de póliza": "An error occurred while creating the account. Please contact your policy advisor."
  ,"debes llenar los datos para poder cambiar tu contraseña": "Complete the required information to change your password."
  ,"no se encontró tu carnet. ponte en contacto con tu asesor!!": "Your ID card was not found. Please contact your advisor!"
  ,"no se encontros información de poliza": "No policy information was found"
  ,"con el puedes gestionar el cobro de la poliza así como también obtener las facturas correspondientes a dichos pagos": "Here you can manage policy collections and obtain the corresponding payment invoices."
  ,"con él puedes gestionar el cobro de la póliza así como también obtener las facturas correspondientes a dichos pagos": "Here you can manage policy collections and obtain the corresponding payment invoices."
  ,"recomendación, no utilices el navegador internet explorer": "Recommendation: Do not use Internet Explorer"
  ,"para aprovechar tu experiencia de usuario": "to get the best user experience."
  ,"registrar": "Register"
  ,"ingresa tu usuario": "Enter your username"
  ,"ingresa tu contraseña": "Enter your password"
  ,"ingresar tu contraseña": "Enter your password"
  ,"ingresa nuevamente tu contraseña": "Enter your password again"
  ,"repite tu contraseña": "Repeat your password"
  ,"ingresa tu correo": "Enter your email address"
  ,"ingresar tu correo @": "Enter your email address"
  ,"ingresa tu dpi": "Enter your ID number"
  ,"ingresa tu número de pasaporte": "Enter your passport number"
  ,"tipo poliza": "Policy type"
  ,"ingrese su enfermedad": "Enter the medical condition"
  ,"ingrese comentarios del siniestro": "Enter comments about the loss"
  ,"ej. dr. juan pérez": "E.g., Dr. John Smith"
  ,"buscar especialidad...": "Search specialty..."
  ,"ingrese su nombre completo": "Enter your full name"
  ,"ej. 55555555": "E.g., 55555555"
  ,"nombre, especialidad o clínica...": "Name, specialty, or clinic..."
  ,"puedes cambiar tu país aquí en cualquier momento para personalizar la información que ves.": "You can change your country here at any time to personalize the information you see."
  ,"--a onclick toogletruefalse1--ver información de tu asesor de cobro/a -": "View your collections advisor's information"
  ,"¿necesita ayuda para encontrar su proveedor?": "Do you need help finding a provider?"
  ,"acceda a nuestra amplia red de médicos, laboratorios y centros de diagnóstico": "Access our extensive network of doctors, laboratories, and diagnostic centers"
  ,"bitacora de reclamo": "Claim activity log"
  ,"cabina de emergencia gastos médicos (502) 40075257": "Medical emergency line (502) 40075257"
  ,"cambiar contraseña": "Change password"
  ,"cerrar aviso": "Close notice"
  ,"cómo llegar": "Directions"
  ,"datos del profesional": "Provider information"
  ,"datos,": "Information"
  ,"datos, si no cuentas con usuario puedes crearlo": "information. If you do not have an account, you can create one"
  ,"descarga facturas pendientes de pago": "Download outstanding invoices"
  ,"descarga información de tus pólizas": "Download your policy information"
  ,"descargar pdf": "Download PDF"
  ,"en este apartado podras recuperar tu usuario y contraseña, el cual sera enviado a tu correo registrado": "Here you can recover your username and password, which will be sent to your registered email address."
  ,"encontramos un error en la creación de tu usuario, debes comunicarte con el asesor de tu póliza": "An error occurred while creating your account. Please contact your policy advisor."
  ,"enviar solicitud": "Submit request"
  ,"éxito": "Success"
  ,"fecha deseada *": "Preferred date *"
  ,"fecha ingreso": "Entry date"
  ,"información general asegurado": "General insured information"
  ,"liquidacion de reclamo no:": "Claim settlement number:"
  ,"llame al número:": "Call the number:"
  ,"no eee encontro información de asesor reclamo dos": "No claims advisor information was found"
  ,"no eee encontro información de gerente": "No manager information was found"
  ,"no hay datos disponibles": "No data available"
  ,"no se encontraron registros con los datos ingresados.": "No records matched the information entered."
  ,"nombre completo *": "Full name *"
  ,"nombre del médico *": "Doctor's name *"
  ,"nombre poliza:": "Policy name:"
  ,"olvide mi contraseña": "I forgot my password"
  ,"pagina": "Page"
  ,"para consultar algún dato debes de seleccionar previamente una póliza.": "Select a policy before viewing its information."
  ,"para la apertura y/ó seguimiento de un reclamo debes contactar directamente a la aseguradora, al siguiente número:": "To open or follow up on a claim, contact the insurance company directly at:"
  ,"por favor, complete todos los datos solicitados antes de enviar.": "Complete all required information before submitting."
  ,"programación sugerida": "Suggested schedule"
  ,"puede adjuntar sus documentos en cualquiera de los siguientes formatos digitales: pdf, jpg, bmp, gif , png, word, excel": "You may attach documents in any of these formats: PDF, JPG, BMP, GIF, PNG, Word, or Excel."
  ,"recibe información de nuestras últimas novedades en productos y asesoria": "Receive updates about our latest products and advisory services"
  ,"reclamo no:": "Claim number:"
  ,"recomendación, no utilices el navegador internet explorer, para aprovechar tu experiencia de usuario": "For the best user experience, do not use Internet Explorer."
  ,"se está consultando la información de tus pólizas, por favor espera un momento": "Retrieving your policy information. Please wait."
  ,"se estan consultando tu información general, por favor espera un momento": "Retrieving your general information. Please wait."
  ,"se estan consultando tu información, para el envío, por favor espera un momento": "Retrieving your information before sending. Please wait."
  ,"se estan creando tu usuario, por favor espera un momento": "Creating your account. Please wait."
  ,"se valido su información y se pudo constatar que no tiene usuario, por lo cual te invitamos a que crees uno": "Your information was validated and no account was found. Please create an account."
  ,"selecciona tu país": "Select your country"
  ,"selecciona una póliza para gestionar su información": "Select a policy to manage its information"
  ,"su usuario y contraseña ya fueron enviados a su bandeja de correo": "Your username and password were sent to your email inbox."
  ,"teléfono de contacto *": "Contact phone *"
  ,"tu información de contacto": "Your contact information"
  ,"usted ya cuenta con un usuario y contraseña, al momento en que se creo el usuario, fue envíado un correo, o bien puede restablecer su contraseña": "You already have a username and password. An email was sent when your account was created, or you can reset your password."
  ,"ver detalle reclamo": "View claim details"
  ,"verifique que su número de teléfono sea correcto.": "Verify that your phone number is correct."
};

export default translations;
